import React from 'react';
import './index.scss'; // CSS dosyasını import edin
import spinnerSVG from '../../assets/img/Curve Bars-1s-200px.svg';
const Spinner = ({ width, height }) => {

    const style = {
        width: width || '100%',
        height: height || '100%'
    };

    return (
        <div className="spinner-wrap" style={style}>
            <img src={spinnerSVG} alt="spinner svg" style={{ width: "120px" }} />
        </div>
    );
}

export default Spinner;
